const cveData = [
  {
    cve: "CVE-2026-33543",
    link: "https://github.com/FOSSBilling/FOSSBilling/security/advisories/GHSA-28mh-j262-q49w",
    cvss: 9.3,
    details:
      "Authentication bypass allows unauthenticated administrator creation",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-33638",
    link: "https://github.com/lin-snow/Ech0/security/advisories/GHSA-m983-7426-5hrj",
    cvss: 5.3,
    details:
      "Authenticated user-list exposed data via public `/api/allusers` endpoint",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-33645",
    link: "https://github.com/ShaneIsrael/fireshare/security/advisories/GHSA-7q8r-vpq3-89m7",
    cvss: 7.1,
    details: "Path Traversal Arbitrary File Write in `/api/uploadChunked`",
    showOnHome: true,
  },
  {
    cve: "CVE-2026-34072",
    link: "https://github.com/fccview/cronmaster/security/advisories/GHSA-9whh-mffv-xvh6",
    cvss: 8.3,
    details:
      "Middleware authentication bypass enabling unauthorized page access and server-action execution",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-34376",
    link: "https://github.com/mrmn2/PdfDing/security/advisories/GHSA-42x7-vvj4-4cj3",
    cvss: 7.5,
    details: "Password-protected share bypass via direct serve endpoint",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-34832",
    link: "https://github.com/Erudika/scoold/security/advisories/GHSA-g5fv-xw88-vw44",
    cvss: 6.5,
    details: "Cross-Account Feedback Deletion (IDOR)",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-35052",
    link: "https://github.com/man-group/dtale/security/advisories/GHSA-436g-fhfc-9g5w",
    cvss: 5.3,
    details: "Remote Code Execution through redis/shelf storage",
    showOnHome: true,
  },
  {
    cve: "CVE-2026-39355",
    link: "https://github.com/MGeurts/genealogy/security/advisories/GHSA-2rq7-jqm7-w8x4",
    cvss: 9.9,
    details: "Missing Authorization in  `TeamController::transferOwnership()` Allows Any Authenticated User to  Hijack Any Team (Broken Access Control)",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-39901",
    link: "https://github.com/monetr/monetr/security/advisories/GHSA-hqxq-hwqf-wg83",
    cvss: 5.7,
    details: "Protected Transactions Deletable via PUT",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-40184",
    link: "https://github.com/mauriceboe/TREK/security/advisories/GHSA-wxx3-84fc-mrx2",
    cvss: 3.7,
    details: "Unauthenticated Access to Uploaded Files in TREK",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-40185",
    link: "https://github.com/mauriceboe/TREK/security/advisories/GHSA-pcr3-6647-jh72",
    cvss: 7.1,
    details: "Missing Authorization on Immich Trip Photo Routes in TREK",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-40262",
    link: "https://github.com/enchant97/note-mark/security/advisories/GHSA-9pr4-rf97-79qh",
    cvss: 8.7,
    details: "Stored XSS via Unrestricted Asset Upload",
    showOnHome: true,
  },
  {
    cve: "CVE-2026-40263",
    link: "https://github.com/enchant97/note-mark/security/advisories/GHSA-w6m9-39cv-2fwp",
    cvss: 3.7,
    details: "Information Disclosure: Username Enumeration via Login Endpoint Timing Side-Channel",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-40265",
    link: "https://github.com/enchant97/note-mark/security/advisories/GHSA-p5w6-75f9-cc2p",
    cvss: 5.9,
    details: "Broken Access Control on Asset Download",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-41418",
    link: "https://github.com/RARgames/4gaBoards/security/advisories/GHSA-8mj9-p99h-jhxp",
    cvss: 5.3,
    details: "User Enumeration via Timing Side-Channel in Authentication Endpoint",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-41419",
    link: "https://github.com/RARgames/4gaBoards/security/advisories/GHSA-rrjq-7x8g-cmgm",
    cvss: 7.6,
    details: "Import Path Traversal Leads to Arbitrary File Read",
    showOnHome: true,
  },
  {
    cve: "CVE-2026-41478",
    link: "https://github.com/saltcorn/saltcorn/security/advisories/GHSA-jp74-mfrx-3qvh",
    cvss: 9.9,
    details: "SQL Injection via Unparameterized Sync Endpoints (maxLoadedId)",
    showOnHome: true,
  },
  {
    cve: "CVE-2026-41518",
    link: "https://github.com/chartbrew/chartbrew/security/advisories/GHSA-6q2j-365c-7gqf",
    cvss: 7.6,
    details: "Stored DOM XSS via Chart Tooltip innerHTML (ChartDatasetConfig.legend)",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-42092",
    link: "https://github.com/titraio/titra/security/advisories/GHSA-4h9p-49hg-vppw",
    cvss: 6.5,
    details: "Sensitive Global Settings Exposed to Any Authenticated User via Meteor Publication",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-42562",
    link: "https://github.com/alextselegidis/plainpad/security/advisories/GHSA-pvfv-wvpm-q6f6",
    cvss: 8.3,
    details: "Privilege Escalation via Unvalidated `admin` Attribute in User Profile Update",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-42564",
    link: "https://github.com/fccview/jotty/security/advisories/GHSA-7843-gwq8-g96f",
    cvss: 8.2,
    details: "Unauthenticated Path Traversal Arbitrary File Read in `/api/app-icons/[filename]`",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-43933",
    link: "https://github.com/InvoicePlane/InvoicePlane/security/advisories/GHSA-phh5-3jc3-pm6w",
    cvss: 7.5,
    details:
      "Guest Attachment Access Bypass — Missing Authorization on Get Controller",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44460",
    link: "https://github.com/error311/FileRise/security/advisories/GHSA-84hw-8g73-v3f8",
    cvss: 7.4,
    details: "TOTP Bypass via Setup Endpoint Disclosing Existing Secret",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44708",
    link: "https://github.com/lepture/mistune/security/advisories/GHSA-8g87-j6q8-g93x",
    cvss: 6.1,
    details: "Mistune Math Plugin XSS Escape Bypass",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44719",
    link: "https://github.com/mathesar-foundation/mathesar/security/advisories/GHSA-jh9v-hqw8-5cq8",
    cvss: 5.3,
    details: "Missing collaborator checks allowed access to database-scoped Mathesar metadata",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44897",
    link: "https://github.com/lepture/mistune/security/advisories/GHSA-v87v-83h2-53w7",
    cvss: 6.1,
    details: "Mistune Heading ID Attribute Injection XSS",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44898",
    link: "https://github.com/lepture/mistune/security/advisories/GHSA-6269-cqxg-mhhv",
    cvss: 6.1,
    details: "Mistune TOC Anchor Injection XSS",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-44899",
    link: "https://github.com/lepture/mistune/security/advisories/GHSA-ccfx-mfmx-2fx9",
    cvss: 4.7,
    details: "Mistune Image Directive CSS Injection Vulnerability",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-97703",
    link: "https://github.com/AlchemyCMS/alchemy_cms/security/advisories/GHSA-7m8w-vg9p-qjr6",
    cvss: 5.4,
    details: "Stored XSS in SelectView via Missing Server-Side Option Validation",
    showOnHome: false,
  },
  {
    cve: "CVE-2026-97704",
    link: "https://github.com/AlchemyCMS/alchemy_cms/security/advisories/GHSA-pm72-wq9v-wvfh",
    cvss: 5.4,
    details: "Stored XSS in PictureView figcaption via html_safe on User Caption",
    showOnHome: false,
  },
];

export default cveData;
